import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'common',
    `
    > * {
      margin: 0 0 8px 0;
    }
		`
  ]
]);
